module.exports = __webpack_public_path__ + "img/giving1.8ce23553.png";